module.exports = __webpack_public_path__ + "img/移动高效.382a9905.png";